import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" className="relative py-24 sm:py-32 bg-[#061A14]" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>Dúvidas frequentes</Overline>
        <SectionTitle>
          Tudo o que você precisa saber <Accent>antes de assinar</Accent>.
        </SectionTitle>
        <p className="mt-4 text-sm sm:text-base text-emerald-100/55">
          Sem letra miúda: as duas faturas, os prazos e o cancelamento, explicados.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-white/10 bg-[#0B261E]/60 px-6 data-[state=open]:border-[#00E676]/40 transition-colors duration-300"
            >
              <AccordionTrigger className="text-left font-heading font-semibold text-white hover:text-[#00E676] hover:no-underline py-5 text-sm sm:text-base">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-emerald-100/60 leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
